import React, { useState, useEffect } from "react";
import { Modal, Select, Button, Row } from "antd";
import { useSpaceContent } from "../../hooks/useSpaceContent";
import httpInjectorService from "services/http-injector.service";

export default function MoveModal({
  open,
  onClose,
  node,
  onConfirm,
  spaceid,
}) {
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [selectedParent, setSelectedParent] = useState(null);
  const [spaces, setSpaces] = useState([]);

  const { data: targetContent } = useSpaceContent(selectedSpace);

  useEffect(() => {
    if (open) {
      getSpaces();
      setSelectedSpace(Number(spaceid));
    }
  }, [open]);

  const getSpaces = async () => {
    try {
      const response = await httpInjectorService.getSpaces({
        filter_type: "All_Spaces",
        category_id: null,
      });

      if (response.status === "success") {
        setSpaces(response.data);
      }
    } catch (error) {
      console.error("Error fetching spaces:", error);
    }
  };

  const handleMove = () => {
    onConfirm({
      dragId: node.item_id,
      dropId: selectedParent,
      space_id: selectedSpace,
    });

    handleReset();
  };

  const handleReset = () => {
    setSelectedParent(null);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleReset}
      footer={null}
      title={`Move Content`}
      width={500}
    >
      <div style={{ marginBottom: 16 }}>
        <label>Select Space</label>

        <Select
          value={selectedSpace}
          style={{ width: "100%", marginTop: 6 }}
          placeholder="Select Space"
          onChange={(val) => {
            setSelectedSpace(val);
            setSelectedParent(null);
          }}
          options={spaces.map((s) => ({
            label: s.space_name,
            value: s.space_id,
          }))}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label>Select Parent Location</label>

        <Select
          style={{ width: "100%", marginTop: 6 }}
          placeholder="Root Level"
          allowClear
          onChange={setSelectedParent}
          options={
            targetContent
              ?.filter(
                (item) =>
                  item.item_type === "folder" ||
                  item.item_type === "template" ||
                  (item.item_type === "page" &&
                    item.status === "published")
              )
              .map((item) => ({
                label: item.title,
                value: item.item_id,
              })) || []
          }
        />
      </div>

      <Row justify="end" style={{ gap: 10 }}>
        <Button onClick={handleReset}>Cancel</Button>

        <Button
          type="primary"
          onClick={handleMove}
          style={{
            background: "#7a3db8",
            border: "none",
          }}
        >
          Move
        </Button>
      </Row>
    </Modal>
  );
}